import React from 'react';
import { IIconProps, sizeMap } from './types';

export const OrderIcon = ({ className, size = 'medium' }: IIconProps) => (
  <svg
    className={className}
    width={sizeMap[size].width}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2.84203 14.9714C4.41278 8.70204 10.1722 7.65714 10.1722 7.65714M12.0047 5.82857C13.4487 5.82857 14.8784 6.11236 16.2124 6.66372C17.5464 7.21509 18.7586 8.02324 19.7796 9.04203C20.8006 10.0608 21.6105 11.2703 22.163 12.6014C22.7156 13.9325 22.9905 14.9021 22.9905 16.3429L1 16.3429C1 14.9021 1.29389 13.9325 1.84645 12.6014C2.39901 11.2703 3.20892 10.0608 4.22992 9.04203C5.25093 8.02324 6.46304 7.21509 7.79704 6.66372C9.13105 6.11236 10.5608 5.82857 12.0047 5.82857ZM12.0047 5.82857C12.5108 5.82857 12.921 5.41923 12.921 4.91429C12.921 4.40934 12.5108 4 12.0047 4C11.4987 4 11.0885 4.40934 11.0885 4.91429C11.0885 5.41923 11.4987 5.82857 12.0047 5.82857ZM1.00948 18.1714H23M1.00948 20H23"
      stroke="currentcolor"
      strokeWidth={sizeMap[size].strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
